import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface IArgs {
  listElementSelector?: string;
  side?: 'left' | 'right';
  onClick: () => void;
  filters?: TQueryParams | TFilterValues;
}

export default class BvFiltersShortcutBtn extends Component<IArgs> {
  // Properties
  // ~~~~~

  @tracked scrollContainer?: HTMLElement | null;
  @tracked showScrollButton = false;

  constructor(owner: any, args: IArgs) {
    super(owner, args);
    const { listElementSelector } = this.args;
    this.scrollContainer = document.querySelector(listElementSelector ?? '.bv-app__content');
    if (this.scrollContainer) {
      this.scrollContainer.addEventListener('scroll', this.showScrollToTopBtn);
    }
  }

  willDestroy() {
    this.scrollContainer?.removeEventListener('scroll', this.showScrollToTopBtn);
  }

  @action
  scrollToTop() {
    this.scrollContainer?.scrollTo({ top: 0, behavior: 'smooth' });
  }

  @action
  showScrollToTopBtn() {
    if (this.scrollContainer && this.scrollContainer.scrollTop > 250) {
      this.showScrollButton = true;
    } else {
      this.showScrollButton = false;
    }
  }
}
